import {useGetWard, useGetWardActivities, useGetWardUsers} from '@/modules/wards/api'
import {EventLog, UserAccessLocation, Ward} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  ward: Ward
  users: UserAccessLocation[] | undefined
  activities: EventLog[] | undefined
}

interface Props extends PropsWithChildren {
  ward: Ward
}

const WardContext = createContext<State>({} as State)

export function WardProvider({children, ward: initialWard}: Props) {
  const [ward] = useGetWard(initialWard?.id)
  const [users] = useGetWardUsers(initialWard?.id)
  const [activities] = useGetWardActivities(initialWard?.id)

  return <WardContext.Provider value={{ward: ward || initialWard, users, activities}}>{children}</WardContext.Provider>
}

export function useWardContext() {
  return useContext(WardContext)
}
